module.exports = __webpack_public_path__ + "static/img/v5-3.c7b713ab.png";